import { Code, ConnectError } from '@bufbuild/connect';
import { SortOrder } from 'antd/es/table/interface';

import { AdminUserListStreamSortBy } from 'protocol/api/core/svc_adminka_pb';

import * as usersModel from '../model';

import api from '@/shared/api/api';
import { useAppDispatch } from '@/shared/hooks';


type OpenUserListStream = (params: {
  search: string;
  startFromUserID?: string;
  sortBy?: AdminUserListStreamSortBy;
  sortOrder?: SortOrder;
}) => void;

let abortController: AbortController;

export const useUserListStream = () => {
  const dispatch = useAppDispatch();

  const openUserListStream: OpenUserListStream = async ({
    search,
    startFromUserID = '',
    sortBy,
    sortOrder,
  }) => {
    abortController = new AbortController();

    dispatch(usersModel.actions.setLoading(true));

    try {
      const usersListStream = api.core.admin.adminUserListStream(
        {
          StartFromUserID: startFromUserID,
          SearchString: search,
          Limit: 20,
          Sort: [
            {
              By: sortBy,
              Ascending: sortOrder === 'ascend',
            },
          ],
        },
        { signal: abortController.signal },
      );

      for await (const { Update } of usersListStream) {
        switch (Update.case) {
          case 'InitialUsers': {
            dispatch(usersModel.actions.addMany(Update.value.Users));

            dispatch(usersModel.actions.setLoading(false));
            break;
          }
          case 'UserUpdated': {
            dispatch(usersModel.actions.setOne(Update.value));
            break;
          }

          default: {
            // do nothing
          }
        }
      }
    } catch (err) {
      if (err instanceof ConnectError && err.code !== Code.Canceled) {
        dispatch(usersModel.actions.setLoading(false));

        console.error('AdminUserListStream:: error: ', err);
      }
    }
  };

  const closeUserListStream = (clearStore = true) => {
    abortController.abort();

    if (clearStore) {
      dispatch(usersModel.actions.removeAll());
    }
  };

  return { openUserListStream, closeUserListStream };
};
